import * as Yup from 'yup';
import { Shape } from '../yup_types';
import { AddressTypes, BankAccountInformationTypes, FORM_FIELDS } from '../new-application/new-application-form';
import { TFunction } from 'react-i18next';
import { DeveloperContact, IOwners } from '../../interfaces/merchant';
import { IApplicationView } from '../../interfaces/application_view';
import { validateUrl } from '../../utils/validators';
import { isUSCountry } from '../../utils/utilities';

export interface IApplicationViewFormFieldsTypes {
  [FORM_FIELDS.COMPANY_NAME]: string;
  [FORM_FIELDS.DOING_BUSINESS]: string;
  [FORM_FIELDS.TAX]: string;
  [FORM_FIELDS.IS_BASED_IN_US]: string;
  // [FORM_FIELDS.BUSINESS_TYPE]: string;
  // [FORM_FIELDS.BUSINESS_ESTABLISHED_DATE]: Date,
  // [FORM_FIELDS.PLATFORM_USAGE_PERIOD]: string,
  [FORM_FIELDS.MCC]: string,
  // [FORM_FIELDS.WEB_URL]: string,
  [FORM_FIELDS.DESCRIPTOR]: string,

  [FORM_FIELDS.FIRST_NAME]: string;
  [FORM_FIELDS.LAST_NAME]: string;
  [FORM_FIELDS.EMAIL]: string;
  [FORM_FIELDS.PHONE]: string | number;

  [FORM_FIELDS.CUSTOMER_NAME]: string,
  [FORM_FIELDS.SUPPORT_LINK]: string,
  [FORM_FIELDS.CUSTOMER_EMAIL]: string,
  [FORM_FIELDS.CUSTOMER_PHONE]: string | number,

  // [FORM_FIELDS.INDUSTRY]: string,
  [FORM_FIELDS.URL_NUMBER]: string,
  // [FORM_FIELDS.INFO_AVAILABLE]: string,
  [FORM_FIELDS.URLS]: string[],

  [FORM_FIELDS.OTHER_INFORMATION]: string,
  // [FORM_FIELDS.MAX_SUBSCRIPTION_DURATION]: string,
  // [FORM_FIELDS.IS_TRIAL_PERIOD]: string,
  // [FORM_FIELDS.AVERAGE_PRODUCT]: string,
  // [FORM_FIELDS.PRODUCTS_SOLD]: string,
  [FORM_FIELDS.IS_REGULATED]: string,
  [FORM_FIELDS.IS_RELATED_TO_HEALTH]: string,

  [FORM_FIELDS.MONTHLY_VOLUME]: string | number,
  [FORM_FIELDS.MONTHLY_DECLINES]: string | number,
  [FORM_FIELDS.MONTHLY_TRANSACTIONS]: string | number,
  [FORM_FIELDS.RETURN_RATE]: string | number,
  [FORM_FIELDS.CHARGEBACK_RATE]: string | number,
  [FORM_FIELDS.DECLINE_RATE]: string | number,
}
interface IPrimaryContact {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

interface ICustomerSupportContact {
  customerSupportName: string;
  customerSupportLink: string;
  customerSupportEmail: string;
  customerSupportPhone: string;
}

export interface ITransactionInformation {
  avgSales: string;
  avgDeclineRate: string;
  avgTransactionAmount: string;
  returnsPercent: string;
  chargebackPercentage: string;
  // avgDisputeRate: string;
}

export interface IBusinessModel {
  urlsCount: string;
  // industry: string;
  urls: string[];
  // infoDisclosed: string;
}

export interface IProductInformation {
  // trafficAcquisition?: string[];
  // maxSubDuration: string;
  // trialPeriod: string;
  // avgDeliveryTime: string;
  // productsSold: string;
  regulated: string;
  healthcare: string;
}

export interface ICompanyInformation {
  legalEntityName: string;
  companyName: string;
  dba: string;
  taxId: string;
  legalEntityCountry: string;
  // businessType: string;
  // timeInBusiness: string;
  // ecommercePlatformUsagePeriod: string;
  mcc: string;
  // webSite: string;
  descriptor: string;
}

export interface IApplicationViewFormFieldsReturnTypes {
  id?: string;
  primaryContact: IPrimaryContact;
  customerSupportContact: ICustomerSupportContact;
  transactionInformation: ITransactionInformation;
  developerContact: DeveloperContact;
  businessModel: IBusinessModel;
  productInfo: IProductInformation;
  companyInformation: ICompanyInformation;
  otherInformation: string;
  next?: boolean;
  owners?: IOwners[];
  uploadedDocuments?: any[];
  address: AddressTypes,
  bankAccountInformation: BankAccountInformationTypes;
  documents?: any[];
  declineRate: number;
}
// @ts-ignore
export const getBusinessDetailsValidationSchema = (t: TFunction): Yup.SchemaOf<IApplicationViewFormFieldsTypes> => Yup.object<Shape<IApplicationViewFormFieldsTypes>>().shape({
  [FORM_FIELDS.COMPANY_NAME]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.COMPANY_NAME_REQUIRED')),
  [FORM_FIELDS.DOING_BUSINESS]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.DOING_BUSINESS_REQUIRED')),
  [FORM_FIELDS.ANNUAL_SALES_VOLUME]: Yup.number()
    .min(0, t('NEW_APPLICATION.VALIDATION.ANNUAL_SALES_VOLUME_MIN')),
  // [FORM_FIELDS.DECLINE_RATE]: Yup.number()
  //   .min(0, t('NEW_APPLICATION.VALIDATION.DECLINE_RATE_MIN'))
  //   .max(100, t('NEW_APPLICATION.VALIDATION.DECLINE_RATE_MAX')),
  [FORM_FIELDS.TAX]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.TAX_REQUIRED')),
  [FORM_FIELDS.IS_BASED_IN_US]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.REQUIRED')),
  // [FORM_FIELDS.BUSINESS_TYPE]: Yup.string(),
    // .typeError(t('NEW_APPLICATION.VALIDATION.BUSINESS_TYPE_REQUIRED'))
    // .required(t('NEW_APPLICATION.VALIDATION.BUSINESS_TYPE_REQUIRED')),
  // [FORM_FIELDS.TIME_IN_BUSINESS]: Yup.string(),
  // [FORM_FIELDS.BUSINESS_ESTABLISHED_DATE]: Yup.date()
  //   .typeError(t('NEW_APPLICATION.VALIDATION.BUSINESS_ESTABLISHED_DATE_REQUIRED'))
  //   .required(t('NEW_APPLICATION.VALIDATION.BUSINESS_ESTABLISHED_DATE_REQUIRED')),
  // [FORM_FIELDS.PLATFORM_USAGE_PERIOD]: Yup.string()
  //   .typeError(t('NEW_APPLICATION.VALIDATION.REQUIRED'))
  //   .required(t('NEW_APPLICATION.VALIDATION.REQUIRED')),
  [FORM_FIELDS.MCC]: Yup.string()
    .typeError(t('NEW_APPLICATION.VALIDATION.MCC_REQUIRED'))
    .required(t('NEW_APPLICATION.VALIDATION.MCC_REQUIRED')),
  // [FORM_FIELDS.WEB_URL]: Yup.string()
  //   .url(t('NEW_APPLICATION.VALIDATION.WEB_URL_FORMAT'))
  //   .required(t('NEW_APPLICATION.VALIDATION.WEB_URL_REQUIRED')),
  [FORM_FIELDS.DESCRIPTOR]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.DESCRIPTOR_REQUIRED')),

  [FORM_FIELDS.FIRST_NAME]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.FIRST_NAME_REQUIRED')),
  [FORM_FIELDS.LAST_NAME]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.LAST_NAME_REQUIRED')),
  [FORM_FIELDS.EMAIL]: Yup.string()
    .email(t('NEW_APPLICATION.VALIDATION.EMAIL_ERROR_TEXT'))
    .required(t('NEW_APPLICATION.VALIDATION.EMAIL_REQUIRED')),
  [FORM_FIELDS.PHONE]: Yup.number()
    .test('is-valid-phone', t('NEW_APPLICATION.VALIDATION.VALID_PHONE'), (value) => {
      if (!value) return true;
      const phoneRegex = /^[0-9]{10,15}$/;
      return phoneRegex.test(value.toString());
    })
    .typeError(t('NEW_APPLICATION.VALIDATION.NUMBER_ERROR_TEXT'))
    .required(t('NEW_APPLICATION.VALIDATION.PHONE_REQUIRED')),

  [FORM_FIELDS.CUSTOMER_NAME]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.CUSTOMER_NAME_REQUIRED')),
  [FORM_FIELDS.SUPPORT_LINK]: Yup.string()
    .url(t('NEW_APPLICATION.VALIDATION.SUPPORT_LINK_FORMAT')),
  [FORM_FIELDS.CUSTOMER_EMAIL]: Yup.string()
    .email(t('NEW_APPLICATION.VALIDATION.EMAIL_ERROR_TEXT'))
    .required(t('NEW_APPLICATION.VALIDATION.EMAIL_REQUIRED')),
  [FORM_FIELDS.CUSTOMER_PHONE]: Yup.number()
    .test('is-valid-phone', t('NEW_APPLICATION.VALIDATION.VALID_PHONE'), (value) => {
      if (!value) return true;
      const phoneRegex = /^[0-9]{10,15}$/;
      return phoneRegex.test(value.toString());
    })
    .typeError(t('NEW_APPLICATION.VALIDATION.NUMBER_ERROR_TEXT'))
    .required(t('NEW_APPLICATION.VALIDATION.PHONE_REQUIRED')),

  // [FORM_FIELDS.INDUSTRY]: Yup.string()
  //   .required(t('NEW_APPLICATION.VALIDATION.INDUSTRY_REQUIRED')),
  [FORM_FIELDS.URL_NUMBER]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.URL_NUMBER_REQUIRED')),
  // [FORM_FIELDS.INFO_AVAILABLE]: Yup.string()
  //   .required(t('NEW_APPLICATION.VALIDATION.REQUIRED')),
  [FORM_FIELDS.URLS]: Yup.array().of(Yup.string())
    .test('no site', t('NEW_APPLICATION.VALIDATION.URLS_REQUIRED'), (item) => {
      return Boolean(item.length);
    })
    .test('valid url', t('NEW_APPLICATION.VALIDATION.URLS_FORMAT'), (item) => {
      const res = item.some(el => !validateUrl(el));
      return !res;
    })
    .typeError(t('NEW_APPLICATION.VALIDATION.WHITELISTED_URLS_REQUIRED'))
    .required(t('NEW_APPLICATION.VALIDATION.URLS_REQUIRED')),

  [FORM_FIELDS.OTHER_INFORMATION]: Yup.string(),
  // [FORM_FIELDS.MAX_SUBSCRIPTION_DURATION]: Yup.string()
  //   .required(t('NEW_APPLICATION.VALIDATION.MAX_SUBSCRIPTION_DURATION_REQUIRED')),
  // [FORM_FIELDS.IS_TRIAL_PERIOD]: Yup.string()
  //   .required(t('NEW_APPLICATION.VALIDATION.REQUIRED')),
  // [FORM_FIELDS.AVERAGE_PRODUCT]: Yup.string()
  //   .required(t('NEW_APPLICATION.VALIDATION.AVERAGE_PRODUCT_REQUIRED')),
  [FORM_FIELDS.IS_REGULATED]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.IS_REGULATED_REQUIRED')),
  [FORM_FIELDS.IS_RELATED_TO_HEALTH]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.IS_RELATED_TO_HEALTH_REQUIRED')),

  [FORM_FIELDS.MONTHLY_VOLUME]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.MONTHLY_VOLUME_REQUIRED')),
  [FORM_FIELDS.MONTHLY_DECLINES]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.MONTHLY_DECLINES_REQUIRED')),
  [FORM_FIELDS.MONTHLY_TRANSACTIONS]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.MONTHLY_TRANSACTIONS_REQUIRED')),
  [FORM_FIELDS.RETURN_RATE]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.RETURN_RATE_REQUIRED')),
  [FORM_FIELDS.CHARGEBACK_RATE]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.CHARGEBACK_RATE_REQUIRED')),
  [FORM_FIELDS.DECLINE_RATE]: Yup.string()
});

export const convertToApplicationViewInitialValues = (data: IApplicationView): any => {
  return ({
  [FORM_FIELDS.COMPANY_NAME]: data?.companyInformation?.legalEntityName || '',
  [FORM_FIELDS.DOING_BUSINESS]: data?.companyInformation?.dba || '',
  [FORM_FIELDS.TAX]: data?.companyInformation?.taxId || '',
  [FORM_FIELDS.IS_BASED_IN_US]: data?.companyInformation?.legalEntityCountry || '',
  // [FORM_FIELDS.BUSINESS_TYPE]: data?.companyInformation?.businessType || '',
  // [FORM_FIELDS.TIME_IN_BUSINESS]: data?.companyInformation?.timeInBusiness || '',
  // [FORM_FIELDS.PLATFORM_USAGE_PERIOD]: data?.companyInformation?.ecommercePlatformUsagePeriod || '',
  [FORM_FIELDS.MCC]: data?.companyInformation?.mcc || '',
  // [FORM_FIELDS.WEB_URL]: data?.companyInformation?.website || '',
  [FORM_FIELDS.DESCRIPTOR]: data?.companyInformation?.descriptor || '',

  [FORM_FIELDS.FIRST_NAME]: data?.primaryContact?.firstName || '',
  [FORM_FIELDS.LAST_NAME]: data?.primaryContact?.lastName || '',
  [FORM_FIELDS.EMAIL]: data?.primaryContact?.email || '',
  [FORM_FIELDS.PHONE]: data?.primaryContact?.phone || '',

  [FORM_FIELDS.CUSTOMER_NAME]: data?.customerSupportContact?.customerSupportName || '',
  [FORM_FIELDS.SUPPORT_LINK]: data?.customerSupportContact?.customerSupportLink || '',
  [FORM_FIELDS.CUSTOMER_EMAIL]: data?.customerSupportContact?.customerSupportEmail || '',
  [FORM_FIELDS.CUSTOMER_PHONE]: data?.customerSupportContact?.customerSupportPhone || '',

    [FORM_FIELDS.DEVELOPER_FIRST_NAME]: data?.developerContact?.developerFirstName ?? '',
    [FORM_FIELDS.DEVELOPER_LAST_NAME]: data?.developerContact?.developerLastName ?? '',
    [FORM_FIELDS.DEVELOPER_EMAIL]: data?.developerContact?.developerEmail ?? '',
    [FORM_FIELDS.DEVELOPER_PHONE]: data?.developerContact?.developerPhone ?? '',

    [FORM_FIELDS.LINE_1]: data?.address ? data?.address?.line1 : '',
    [FORM_FIELDS.LINE_2]: data?.address ? data?.address?.line2 : '',
    [FORM_FIELDS.CITY]: data?.address ? data?.address?.city : '',
    [FORM_FIELDS.ZIPCODE]: data?.address ? data?.address?.zipCode : '',
    [FORM_FIELDS.COUNTRY]: data?.address?.country ? data?.address?.country : 'US',
    [FORM_FIELDS.STATE]: data?.address ? data?.address?.state : '',

    [FORM_FIELDS.DDA_TYPE]: data?.bankAccountInformation ? data?.bankAccountInformation?.ddaType : '',
    [FORM_FIELDS.ACCOUNT_NUMBER]: data?.bankAccountInformation ? data?.bankAccountInformation?.accountNumber : '',
    [FORM_FIELDS.MASKED_ACCOUNT_NUMBER]: data?.bankAccountInformation ? data?.bankAccountInformation?.maskedAccountNumber : '',
    [FORM_FIELDS.MASKED_ROUTING_NUMBER]: data?.bankAccountInformation ? data?.bankAccountInformation?.maskedRoutingNumber : '',
    [FORM_FIELDS.ROUTING_NUMBER]: data?.bankAccountInformation ? data?.bankAccountInformation?.routingNumber : '',
    [FORM_FIELDS.BANK_NAME]: data?.bankAccountInformation ? data?.bankAccountInformation?.bankName : '',

  // [FORM_FIELDS.INDUSTRY]: data?.businessModel?.industry || '',
  [FORM_FIELDS.URL_NUMBER]: data?.businessModel?.urlsCount || '',
  // [FORM_FIELDS.INFO_AVAILABLE]: data?.businessModel?.infoDisclosed || '',
  [FORM_FIELDS.URLS]: data?.businessModel?.urls || '',

  [FORM_FIELDS.OTHER_INFORMATION]: data?.otherInformation || '',
  // [FORM_FIELDS.MAX_SUBSCRIPTION_DURATION]: data?.productInfo?.maxSubDuration || '',
  // [FORM_FIELDS.IS_TRIAL_PERIOD]: data?.productInfo?.trialPeriod || '',
  // [FORM_FIELDS.AVERAGE_PRODUCT]: data?.productInfo?.avgDeliveryTime || '',
  // [FORM_FIELDS.PRODUCTS_SOLD]: data?.productInfo?.productsSold || '',
  [FORM_FIELDS.IS_REGULATED]: data?.productInfo?.regulated || '',
  [FORM_FIELDS.IS_RELATED_TO_HEALTH]: data?.productInfo?.healthcare || '',

  [FORM_FIELDS.MONTHLY_VOLUME]: data?.transactionInformation?.avgSales || '',
  [FORM_FIELDS.MONTHLY_DECLINES]: data?.transactionInformation?.avgDeclineRate || '',
  [FORM_FIELDS.MONTHLY_TRANSACTIONS]: data?.transactionInformation?.avgTransactionAmount || '',
  [FORM_FIELDS.RETURN_RATE]: data?.transactionInformation?.returnsPercent || '',
  [FORM_FIELDS.CHARGEBACK_RATE]: data?.transactionInformation?.chargebackPercentage || '',
  [FORM_FIELDS.DECLINE_RATE]: data?.transactionInformation?.declineRate || '',

  [FORM_FIELDS.SPECIAL_TERMS]: data?.specialTerms || '',
});};

export const formattedApplicationViewData = (formikValues): IApplicationViewFormFieldsReturnTypes => ({
  primaryContact: {
    firstName: formikValues[FORM_FIELDS.FIRST_NAME],
    lastName: formikValues[FORM_FIELDS.LAST_NAME],
    email: formikValues[FORM_FIELDS.EMAIL],
    phone: formikValues[FORM_FIELDS.PHONE],
  },
  customerSupportContact: {
    customerSupportName: formikValues[FORM_FIELDS.CUSTOMER_NAME],
    customerSupportLink: formikValues[FORM_FIELDS.SUPPORT_LINK],
    customerSupportEmail: formikValues[FORM_FIELDS.CUSTOMER_EMAIL],
    customerSupportPhone: formikValues[FORM_FIELDS.CUSTOMER_PHONE],
  },
  developerContact: {
    developerFirstName: formikValues[FORM_FIELDS.DEVELOPER_FIRST_NAME],
    developerLastName: formikValues[FORM_FIELDS.DEVELOPER_LAST_NAME],
    developerEmail: formikValues[FORM_FIELDS.DEVELOPER_EMAIL],
    developerPhone: formikValues[FORM_FIELDS.DEVELOPER_PHONE],
  },
  transactionInformation: {
    avgSales: formikValues[FORM_FIELDS.MONTHLY_VOLUME],
    avgDeclineRate: formikValues[FORM_FIELDS.MONTHLY_DECLINES],
    avgTransactionAmount: formikValues[FORM_FIELDS.MONTHLY_TRANSACTIONS],
    returnsPercent: formikValues[FORM_FIELDS.RETURN_RATE],
    chargebackPercentage: formikValues[FORM_FIELDS.CHARGEBACK_RATE],
    // declineRate: formikValues[FORM_FIELDS.DECLINE_RATE],
  },
  businessModel: {
    urlsCount: formikValues[FORM_FIELDS.URL_NUMBER],
    // industry: formikValues[FORM_FIELDS.INDUSTRY],
    urls: formikValues[FORM_FIELDS.URLS],
    // infoDisclosed: formikValues[FORM_FIELDS.INFO_AVAILABLE],
  },
  productInfo: {
    // maxSubDuration: formikValues[FORM_FIELDS.MAX_SUBSCRIPTION_DURATION],
    // trialPeriod: formikValues[FORM_FIELDS.IS_TRIAL_PERIOD],
    // avgDeliveryTime: formikValues[FORM_FIELDS.AVERAGE_PRODUCT],
    // productsSold: formikValues[FORM_FIELDS.PRODUCTS_SOLD],
    regulated: formikValues[FORM_FIELDS.IS_REGULATED],
    healthcare: formikValues[FORM_FIELDS.IS_RELATED_TO_HEALTH],
  },
  companyInformation: {
    legalEntityName: formikValues[FORM_FIELDS.COMPANY_NAME],
    companyName: formikValues[FORM_FIELDS.COMPANY_NAME],
    dba: formikValues[FORM_FIELDS.DOING_BUSINESS],
    taxId: formikValues[FORM_FIELDS.TAX],
    legalEntityCountry: formikValues[FORM_FIELDS.IS_BASED_IN_US],
    // businessType: formikValues[FORM_FIELDS.BUSINESS_TYPE],
    // timeInBusiness: formikValues[FORM_FIELDS.TIME_IN_BUSINESS],
    // ecommercePlatformUsagePeriod: formikValues[FORM_FIELDS.PLATFORM_USAGE_PERIOD],
    mcc: formikValues[FORM_FIELDS.MCC],
    // webSite: formikValues[FORM_FIELDS.WEB_URL],
    descriptor: formikValues[FORM_FIELDS.DESCRIPTOR],
  },
  otherInformation: formikValues[FORM_FIELDS.OTHER_INFORMATION],
  address: {
    line1: formikValues?.[FORM_FIELDS.LINE_1],
    line2: formikValues?.[FORM_FIELDS.LINE_2],
    zipCode: formikValues?.[FORM_FIELDS.ZIPCODE]?.toString(),
    state: isUSCountry(formikValues?.[FORM_FIELDS.COUNTRY]) ? formikValues?.[FORM_FIELDS.STATE]: null,
    stateCode: 'ST',
    city: formikValues?.[FORM_FIELDS.CITY],
    country: formikValues?.[FORM_FIELDS.COUNTRY],
  },
  bankAccountInformation: {
    ddaType: formikValues?.[FORM_FIELDS.DDA_TYPE],
    accountNumber: formikValues?.[FORM_FIELDS.ACCOUNT_NUMBER] ? formikValues?.[FORM_FIELDS.ACCOUNT_NUMBER] : null,
    routingNumber: formikValues?.[FORM_FIELDS.ROUTING_NUMBER] ? formikValues?.[FORM_FIELDS.ROUTING_NUMBER] : null,
    maskedAccountNumber: formikValues?.[FORM_FIELDS.MASKED_ACCOUNT_NUMBER],
    maskedRoutingNumber: formikValues?.[FORM_FIELDS.MASKED_ROUTING_NUMBER],
    bankName: formikValues?.[FORM_FIELDS.BANK_NAME]
  },
  declineRate: formikValues[FORM_FIELDS.DECLINE_RATE],
});
